import {Injectable} from "@angular/core";
import {StorageBase} from "./Storage/StorageBase";
import {LocalStorageService, SessionStorageService} from "./index";

@Injectable()
export class GlobalService implements NPS.Common.IGlobalService {
    public cacheFactory = new StorageBase();
    public localStorage = new LocalStorageService();
    public sessionStorage = new SessionStorageService();
    public window: Window = window;
    public location: Location = location;

    constructor() {
    }
}


// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/GlobalService.ts